import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError, EMPTY, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  catchError,
  map,
  publishReplay,
  refCount,
  share,
} from 'rxjs/operators';
import { AppConfigService } from '../services/config.service';

let headers = new HttpHeaders({
  // 'Content-Type': 'application/json',
  // 'Access-Control-Allow-Origin':  'http://127.0.0.1:4200',
  // 'Access-Control-Allow-Methods': ', GET',
  // 'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  // 'Access-Control-Allow-Credentials': 'true',
  user_token: localStorage.getItem('token'),
});
let options = { headers: headers };

@Injectable({
  providedIn: 'root',
})
export class SampleService {
  private url = this.conf.appConfig.apiBaseUrl;

  getDashboardData(refresh: number = 0) {
    const url = `${this.url}/api/loader/dashboard?refresh=${refresh}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getSamples(billId) {
    const url = `${this.url}/api/lab/sample/getall?pagesize=100&bill_id=${billId}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getResults(startdate: string, enddate: string, dept_code: number = 0, pageno:number=1, pagesize:number =100, is_finalized:number=-1) {
    const url = `${this.url}/api/lab/result/getall?startdate=${startdate}&enddate=${enddate}&dept_code=${dept_code}&pageno=${pageno}&pagesize=${pagesize}&is_finalized=${is_finalized}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getResultsXray(startdate: string, enddate: string, pageno:number =1, pagesize:number=100) {
    const url = `${this.url}/api/lab/result/getall?startdate=${startdate}&enddate=${enddate}&pageno=${pageno}&pagesize=${pagesize}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  searchResults(
    startdate: string,
    enddate: string,
    name: string,
    phone: string,
    sex: string,
    dept_code: number = 0,
    pageno:number=1,
    pagesize:number=100,
    is_finalized:number=-1
  ) {
    const url = `${this.url}/api/lab/result/getall?pagesize=${pagesize}&pageno=${pageno}&startdate=${startdate}&enddate=${enddate}&name=${name}&phone=${phone}&sex=${sex}&dept_code=${dept_code}&is_finalized=${is_finalized}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getResultsById(billId) {
    const url = `${this.url}/api/lab/result/getall?bill_id=${billId}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getResultByVerify(bill_id) {
    const url = `${this.url}/api/lab/result/getall?is_verified=1&pagesize=100&bill_id=${bill_id}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getBarcode(bill_id: number, dept_id: number) {
    const data = {
      bill_id,
      // sub_dept_id,
      dept_id,
    };
    console.log(data);
    const url = `${this.url}/api/lab/sample/barcode/generate`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
  barcodeFetsamples(text) {
    const url = `${this.url}/api/lab/sample/barcode/fetchsamples?barcodeText=${text}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  updateIsVerified(
    id: number,
    bill_id: number,
    is_collect_action: boolean,
    is_acknowledge_action: boolean,
    is_verify_action: boolean
  ) {
    const data = {
      id,
      bill_id,
      is_collect_action,
      is_acknowledge_action,
      is_verify_action,
    };
    console.log(data);
    const url = `${this.url}/api/lab/sample/update`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  updateRecord(id, bill_id, is_collect_action, is_acknowledge_action) {
    const data = {
      id,
      bill_id,
      is_collect_action,
      is_acknowledge_action,
    };
    console.log(data);
    const url = `${this.url}/api/lab/sample/update`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getTemplate(service_code) {
    const url = `${this.url}/api/lab/result/format?service_code=${service_code}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getdetails(result_id) {
    let option = { headers: headers };
    const url = `${this.url}/api/lab/result/getdetails?result_id=${result_id}`;

    return this.client.get(url, option).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getPrintResult(result_id) {
    const url = `${this.url}/api/lab/result/print?result_id=${result_id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getPrintResultBulk(result_ids) {
    const url = `${this.url}/api/lab/result/print?result_ids=${result_ids}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  checkPaymentStatus(id) {
    const url = `${this.url}/api/encounter/getall?id=${id}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  printReciept(receipt_no) {
    const url = `${this.url}/api/payments/receipt?receipt_no=${receipt_no}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getPayments(bill_id) {
    const url = `${this.url}/api/payments/viewpaymemts?bill_id=${bill_id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getPayment(startdate, enddate, name) {
    const url = `${this.url}/api/payments/viewpaymemts?pagesize=100&startdate=${startdate}&enddate=${enddate}&name=${name}`;
    // const url = `${this.url}/api/payments/viewpaymemts`;
    console.log(url);
    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  refundPayment(
    payment_mode: string,
    payment_ref: string,
    payment_date: string,
    service_code: number,
    refund_date: string,
    receipt_no: number,
    receipt_id: number,
    bill_id: number,
    refund_amount: number,
    refund_reason: string,
    service_codes: []
  ) {
    const data = {
      payment_mode,
      payment_ref,
      payment_date,
      service_code,
      refund_date,
      receipt_no,
      receipt_id,
      bill_id,
      refund_amount,
      refund_reason,
      service_codes,
    };
    console.log(data);
    const url = `${this.url}/api/payments/refund/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  postResultDetail(result_id, formatstr) {
    const data = {
      result_id,
      formatstr,
    };
    console.log(data);
    const url = `${this.url}/api/lab/result/savedetails`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  finalizeScan(user_id, result_id, is_finalized) {
    const data = {
      user_id,
      result_id,
      is_finalized,
    };
    console.log(data);
    const url = `${this.url}/api/lab/result/finalize`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getDrs() {
    const url = `${this.url}/api/accounts/user/getall`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getRadiologist(email) {
    let option = { headers: headers };
    const url = `${this.url}/api/accounts/user/getall?email=${email}`;
    console.log(url);
    
    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, option).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postResultTemplate(sample_id, format_code, formatstr) {
    const data = {
      sample_id,
      format_code,
      formatstr,
    };
    console.log(data);
    const url = `${this.url}/api/lab/result/start`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  postResultFinalize(result_id, is_finalized) {
    const data = {
      result_id,
      is_finalized,
    };
    console.log(data);
    const url = `${this.url}/api/lab/result/finalize`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  postResultFinalizeScan(result_id, is_finalized, user_id) {
    const data = {
      result_id,
      is_finalized,
      user_id,
    };
    console.log(data);
    const url = `${this.url}/api/lab/result/finalize`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  dispatchResult(
    result_id,
    is_dispatched_to_patient,
    is_dispatched_to_reception
  ) {
    const data = {
      result_id,
      is_dispatched_to_patient,
      is_dispatched_to_reception,
    };
    console.log(data);
    const url = `${this.url}/api/lab/result/dispatch/update`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  mergePrintResults(bill_id, push_online, machine_data, letterhead, pdf) {
    let option = { headers: headers };
    const url = `${this.url}/api/lab/result/mergeprint?bill_id=${bill_id}&push_online=${push_online}&machine_data=${machine_data}&letterhead=${letterhead}&pdf=${pdf}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  pushFile(result_id) {
    const url = `${this.url}/api/files2/pushonline?resultid=${result_id}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  pushOnlineObs(
    LocalResultId,
    ResultHtmlBody,
    NotifyDefaultRefDoctor,
    RefDoctorEmail,
    RefDoctorPhone,
    RefDoctorName
  ) {
    // let lstLocalResultId = JSON.parse(ids);
    // console.log(ids);

    const data = {
      LocalResultId,
      ResultHtmlBody,
      NotifyDefaultRefDoctor,
      RefDoctorEmail,
      RefDoctorPhone,
      RefDoctorName,
    };
    console.log(data);
    const url = `${this.url}/api/local/result/obs/pushonline`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
  pushOnline(
    LocalResultId,
    StartDate,
    EndDate,
    ids,
    NotifyDefaultRefDoctor,
    RefDoctorEmail,
    RefDoctorPhone,
    RefDoctorName
  ) {
    let lstLocalResultId = JSON.parse(ids);
    console.log(ids);

    const data = {
      LocalResultId,
      StartDate,
      EndDate,
      lstLocalResultId,
      NotifyDefaultRefDoctor,
      RefDoctorEmail,
      RefDoctorPhone,
      RefDoctorName,
    };
    console.log(data);
    const url = `${this.url}/api/local/result/pushonline`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  fileSave(resultId, fileName, fileBase64str) {
    const data = {
      resultId,
      fileName,
      fileBase64str,
    };
    console.log(data);
    const url = `${this.url}/api/files2/save`;
    console.log(url);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  filePush(result_id) {
    const url = `${this.url}/api/files2/pushonline?resultId=${result_id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getFile(result_id) {
    const url = `${this.url}/api/files2/fetch?resultId=${result_id}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  pushForReview(
    LocalResultId,
    FinalizerEmail,
    FinalizerName,
    Title,
    MessageBody
  ) {
    const data = {
      LocalResultId,
      FinalizerEmail,
      FinalizerName,
      Title,
      MessageBody,
    };
    console.log(data);
    const url = `${this.url}/api/local/result/sendforreview`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  checkStatus(id) {
    const url = `${this.url}/api/local/result/checkreviewstatus?result_id=${id}&dorefresh=1`;
    console.log(url);
    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getdr() {
    const url = `${this.url}/api/employees/getallemployees?category_id=1`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  addQc(
    Id: number,
    Name: string,
    Unit: string,
    Min: Number,
    Normal: Number,
    Max: Number,
    StartDate: String,
    StopDate: String,
    QcValues: [],
    QcValuesCount: Number
  ) {
    const data = [
      {
        Id,
        Name,
        Unit,
        Min,
        Max,
        Normal,
        StartDate,
        StopDate,
        QcValues,
        QcValuesCount,
      },
    ];
    console.log(data);
    const url = `${this.url}/api/qc/param/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  getQc() {
    const url = `${this.url}/api/qc/param/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getQcValues(id) {
    const url = `${this.url}/api/qc/values?param_id=${id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  constructor(private client: HttpClient, private conf: AppConfigService) {}
}
